module.exports = __webpack_public_path__ + "static/media/0223_IMG_LE_SOL_MEGALITH_MEGABROWN.7bddd964.png";